import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import Img from "gatsby-image"
import { isBrowser } from "react-device-detect"
import AppleStore from "../../images/appstore.png"
import GooglePlay from "../../images/googleplay.png"

const query = graphql`
  {
    stacja: file(relativePath: { eq: "stacja-ladowania.png" }) {
      childImageSharp {
        fluid(quality: 60) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    logo: file(relativePath: { eq: "orlen-charge.png" }) {
      childImageSharp {
        fluid(quality: 70) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const Aplikacja = () => {
  const data = useStaticQuery(query)

  return (
    <section className="aplikacja pt-5">
      <div className="container">
        <h2 className="text-center mb-5 font-light section-title">
          APLIKACJA <strong>ORLEN Charge</strong>
        </h2>
        <div className="row relative pt-lg-5">
          <div className="col-12 col-lg-6 mb-lg-5">
            <div
              className="d-flex flex-column flex-md-row align-items-center ie11animfix"
              data-sal={isBrowser ? "slide-up" : ""}
              data-sal-delay="500"
              data-sal-duration="600"
              data-sal-easing="ease"
            >
              <Img
                fluid={data.logo.childImageSharp.fluid}
                alt=""
                className="flex-shrink-0 logo-orlen-charge"
              />
              <div className="ml-md-4 text-center text-md-left">
                <p className="font-bold font-xxl">
                  Chcesz szybko i&nbsp;wygodnie korzystać z&nbsp;ładowarek
                  ORLEN?
                </p>
                <p className="font-light mb-0">
                  Pobierz aplikację ORLEN Charge.
                </p>
              </div>
            </div>
            <div
              className="ramka my-4 my-md-5 py-4 px-2 ie11animfix"
              data-sal={isBrowser ? "slide-up" : ""}
              data-sal-delay="700"
              data-sal-duration="600"
              data-sal-easing="ease"
            >
              <p className="font-light text-center">
                Aplikacja ORLEN Charge jest dostępna na iOS, Android,
                w&nbsp;sklepach App Store i&nbsp;Google Play
                <br />
                <br />
                <a
                  href="https://apps.apple.com/us/app/orlen-charge/id1478111353"
                  target="_blank"
                  rel="noreferrer"
                  title="zainstaluj aplikację z App Store"
                >
                  <img src={AppleStore} alt="" className="img-fluid" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=pl.orlen.charge"
                  target="_blank"
                  rel="noreferrer"
                  title="zainstaluj aplikację z Google Play"
                >
                  <img src={GooglePlay} alt="" className="img-fluid" />
                </a>
              </p>
            </div>
            <Link
              to="jak-dziala-aplikacja"
              className="link-more"
              title="Dowiedz się więcej o aplikacji"
            >
              Więcej o&nbsp;aplikacji
            </Link>
            
          </div>
        </div>
      </div>
      <div className="grafika-1">
        <Img
          fluid={data.stacja.childImageSharp.fluid}
          className="img-fluid gfx-1"
        />
      </div>
    </section>
  )
}

export default Aplikacja
